import { getRequest } from '@/core';
import { settings } from '@/requests';

export default async function syncGlobalAddresses() {
	let url = settings.getAllAvailableSettings();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}